import type { orders as ordersEn } from "../en/orders";

export const orders: typeof ordersEn = {
  pax: {
    adults_one: "{{count}} dospělý",
    adults_few: "{{count}} dospělí",
    adults_other: "{{count}} dospělých",
    children_one: "{{count}} dítě",
    children_few: "{{count}} děti",
    children_other: "{{count}} dětí",
  },
  list: {
    title: "Objednávky",
    subtitle: "Správa poptávek a objednávek",
    newOrder: "Nová objednávka",
    tableView: "Tabulka",
    kanbanView: "Kanban",
    statNewInquiries: "Nové poptávky",
    statAwaitingPayment: "Čeká na platbu",
    statFullyPaid: "Plně zaplaceno",
    statTotalValue: "Celková hodnota",
    searchPlaceholder: "Hledat podle čísla objednávky, zákazníka, e-mailu nebo zájezdu…",
    facetAgent: "Agent",
    unassigned: "Nepřiřazeno",
    empty: "Žádné objednávky nenalezeny",
    colOrder: "Objednávka",
    details: "Detail",
  },
  kanban: {
    title: "Kanban objednávek",
    subtitle: "Přetažením karet změníte stav objednávky",
    loadError: "Objednávky se nepodařilo načíst.",
    cancelledHidden_one: "{{count}} stornovaná objednávka (v kanbanu se nezobrazuje)",
    cancelledHidden_few: "{{count}} stornované objednávky (v kanbanu se nezobrazují)",
    cancelledHidden_other: "{{count}} stornovaných objednávek (v kanbanu se nezobrazují)",
    emptyColumn: "Žádné objednávky",
    ppl: "{{n}} os.",
    priceLabel: "Cena:",
  },
  new: {
    title: "Nová objednávka",
    subtitle: "Ruční vytvoření objednávky",
    steps: {
      trip: "Zájezd",
      customer: "Zákazník",
      details: "Detaily",
      review: "Souhrn",
    },
    leadDepartureNotRunning: "Odjezd z poptávky ({{date}}) se nekoná, vyberte jiný termín.",
    hotel: {
      title: "Hotelový pobyt z poptávky",
      stay: "Termín pobytu",
      nights_one: "{{count}} noc",
      nights_few: "{{count}} noci",
      nights_other: "{{count}} nocí",
      room: "Pokoj",
      meal: "Strava",
      departure: "Odlet z",
      included: "v ceně",
    },
    selectTripTitle: "Vyberte zájezd a termín",
    searchTrips: "Hledat zájezdy…",
    days_one: "{{count}} den",
    days_few: "{{count}} dny",
    days_other: "{{count}} dní",
    requestedDate: "Požadovaný termín",
    anyDayHint: "Zákazník si pro tento zážitek může vybrat libovolný den.",
    availableDates: "Dostupné termíny",
    spots_one: "{{count}} místo",
    spots_few: "{{count}} místa",
    spots_other: "{{count}} míst",
    noActiveDates: "Žádné aktivní termíny",
    continue: "Pokračovat",
    existingCustomer: "Stávající zákazník",
    newCustomer: "Nový zákazník",
    searchCustomers: "Hledat podle jména, e-mailu nebo telefonu…",
    customerNotFound: "Zákazník nenalezen.",
    createNew: "Vytvořit nového",
    firstNameRequired: "Jméno *",
    lastNameRequired: "Příjmení *",
    emailRequired: "E-mail *",
    street: "Ulice",
    city: "Město",
    zip: "PSČ",
    createCustomer: "Vytvořit zákazníka",
    selectedCustomer: "Vybraný zákazník: {{name}} ({{email}})",
    detailsTitle: "Detaily objednávky",
    adultsCount: "Počet dospělých",
    childrenCount: "Počet dětí (do 12 let)",
    travelers: "Cestující",
    travelerPlaceholder: "Jméno {{n}}. cestujícího",
    initialStatus: "Výchozí stav objednávky",
    customerNotes: "Poznámky zákazníka",
    customerNotesPlaceholder: "Zvláštní požadavky, preference…",
    internalNotes: "Interní poznámky",
    internalNotesPlaceholder: "Poznámky pro interní použití…",
    reviewTitle: "Souhrn objednávky",
    anyDayDate: "{{date}} (libovolný den)",
    hours_one: "{{count}} hodina",
    hours_few: "{{count}} hodiny",
    hours_other: "{{count}} hodin",
    adultsAtPrice: "{{n}}× dospělý à {{price}}",
    childrenAtPrice: "{{n}}× dítě (50 %) à {{price}}",
    depositHalf: "Záloha (50 %)",
    notesCustomer: "Zákazník:",
    notesInternal: "Interní:",
    creating: "Vytvářím…",
    createOrder: "Vytvořit objednávku",
    createFailed: "Objednávku se nepodařilo vytvořit. Zkuste to prosím znovu.",
  },
  detail: {
    loadError: "Objednávku se nepodařilo načíst.",
    orderNumber: "Objednávka #{{id}}",
    createdAt: "Vytvořeno: {{date}}",
    cancelledBanner: "Tato objednávka byla stornována",
    workflow: {
      inquiry: "Poptávka",
      quoted: "Nabídnuto",
      confirmed: "Potvrzeno",
      deposit: "Záloha",
      paid: "Zaplaceno",
      completed: "Dokončeno",
    },
    paymentAwaiting: "Čeká na platbu",
    paymentDeposit: "Záloha zaplacena",
    paymentFull: "Plně zaplaceno",
    requestedDate: "Požadováno: {{date}}",
    hoursShort: "{{hours}} h",
    priceBreakdown: "Rozpis ceny",
    pricePersons_one: "Cena × {{count}} osoba",
    pricePersons_few: "Cena × {{count}} osoby",
    pricePersons_other: "Cena × {{count}} osob",
    deposit: "Záloha",
    viewProfile: "Zobrazit profil",
    keyDates: "Klíčová data",
    depositDue: "Splatnost zálohy",
    balanceDue: "Splatnost doplatku",
    departure: "Odjezd",
    attribution: "Atribuce",
    source: "Zdroj",
    adClick: "Kliknutí na reklamu",
    utmSource: "UTM source",
    utmMedium: "UTM medium",
    utmCampaign: "UTM campaign",
    lead: "Poptávka",
    viewLead: "Zobrazit poptávku",
    customerNotes: "Poznámky zákazníka",
  },
  margin: {
    title: "Marže",
    revenue: "Tržby",
    supplierCost: "Náklady dodavatelů",
    margin: "Marže",
  },
  whatsDifferent: {
    title: "Čím se tato objednávka liší",
    subtitle: "Odchylky od standardního balíčku — dostane je průvodce.",
  },
  items: {
    title: "Položky objednávky",
    suggestFromNotes: "Navrhnout z poznámek",
    suggestTitle: "Navrhne položky z poznámek zákazníka",
    saveItems: "Uložit položky",
    nothingToAdd:
      "Z poznámek není co přidat. Vložte níže přepis, nebo požadavek žádné úpravy neobsahoval.",
    aiProposed_one: "AI navrhla {{count}} položku:",
    aiProposed_few: "AI navrhla {{count}} položky:",
    aiProposed_other: "AI navrhla {{count}} položek:",
    setPrice: "doplňte cenu",
    reviewPrices: "— zkontrolujte ceny a poté položky uložte.",
    hidePaste: "Skrýt",
    pasteToggle: "Vložit místo toho poznámky z hovoru / Plaud…",
    pastePlaceholder:
      "Vložte poznámky z hovoru / přepis z Plaud — např. ‚chce pětihvězdičkový hotel, přidat plavbu při západu slunce v Halongu pro 2'…",
    suggestFromText: "Navrhnout z tohoto textu",
  },
  confirmations: {
    title: "Příchozí potvrzení",
    scanInbox: "Prohledat schránku",
    hint: "AI přečte PDF přílohy z e-mailů této objednávky a navrhne, kterou rezervaci která potvrzuje.",
    noPdfs: "V e-mailech této objednávky nebyly nalezeny žádné PDF přílohy.",
    truncated: "Příloh existuje více, než bylo prohledáno (zobrazuje se prvních 5).",
    unreadable: "Z tohoto PDF se nepodařilo přečíst údaje",
    attach: "Připojit",
    attached: "Připojeno ✓",
    noBookings: "Na této objednávce nejsou žádné rezervace, ke kterým by šlo přílohu připojit.",
  },
  participants: {
    title: "Účastníci",
    revealTitle: "Zobrazit čísla pasů (akce se loguje)",
    hideTitle: "Skrýt čísla pasů",
    revealPassports: "Zobrazit pasy",
    hidePassports: "Skrýt pasy",
    restricted: "Čísla pasů nejsou pro vaši roli přístupná.",
    firstName: "Jméno",
    lastName: "Příjmení",
    nationality: "Státní příslušnost",
    birthDate: "Datum narození",
    passportNo: "Číslo pasu",
    passportExpiry: "Platnost pasu",
    genderTitle: "Pohlaví (vyžadují ho portály příletových karet)",
    genderEmpty: "Pohlaví —",
    male: "Muž",
    female: "Žena",
    otherGender: "Jiné",
    occupation: "Povolání (vstupní formuláře)",
    dietary: "Strava / poznámky",
    leadPax: "Hlavní",
    removeTitle: "Odebrat účastníka",
    add: "Přidat účastníka",
  },
  audit: {
    title: "Auditní stopa",
    empty: "Zatím žádné auditní události.",
    system: "Systém",
  },
  calculation: {
    title: "Kalkulace (cenotvorba)",
  },
  cancellation: {
    cancelledTitle: "Stornováno",
    stornoFee: "Stornopoplatek",
    refundToCustomer: "Vratka zákazníkovi",
    supplierLoss: "Ztráta u dodavatelů",
    netImpact: "Čistý dopad",
    reason: "Důvod",
    title: "Stornovat objednávku",
    start: "Zahájit storno",
    daysToDeparture: "Dní do odjezdu",
    policyFee: "Poplatek dle podmínek",
    effectiveFee: "Uplatněný poplatek",
    paidSoFar: "Dosud zaplaceno",
    refundDue: "K vrácení",
    servicesToCancel: "Služby ke zrušení",
    waiveFee: "Prominout část poplatku (%)",
    reasonPlaceholder: "Důvod (nepovinné)",
    confirm: "Potvrdit storno",
  },
  timeline: {
    types: {
      email: "E-mail",
      phone: "Telefon",
      note: "Poznámka",
      sms: "SMS",
      statusChange: "Změna stavu",
      payment: "Platba",
      document: "Dokument",
    },
    title: "Komunikace",
    reply: "Odpovědět",
    addEntry: "Přidat záznam",
    replyToPrefix: "Odpověď pro",
    replyViaMailbox: "přes vaši připojenou schránku.",
    replyViaMailboxThreaded: "přes vaši připojenou schránku (ve vlákně).",
    subjectPlaceholder: "Předmět",
    replyPlaceholder: "Napište odpověď…",
    sendFailed: "Odeslání se nezdařilo",
    sendReply: "Odeslat odpověď",
    defaultReplySubject: "Re: vaše poptávka",
    internalNoteSubject: "Interní poznámka",
    notePlaceholder: "Napište interní poznámku… (kolegu zmíníte přes @)",
    phonePlaceholder: "Shrnutí telefonátu…",
    emailPlaceholder: "Obsah komunikace…",
    subjectInputPlaceholder: "Předmět…",
    empty: "Zatím žádná komunikace",
    inbound: "příchozí",
    outbound: "odchozí",
    less: "Méně",
    more: "Více",
  },
  complaints: {
    title: "Reklamace",
    new: "Nová",
    whatPlaceholder: "Čeho se reklamace týká?",
    compensationPlaceholder: "Kompenzace",
    add: "Přidat reklamaci",
    empty: "Žádné reklamace.",
    compensationToPay: "Kompenzace k výplatě (nepovinné)",
    issueCreditNote: "Vystavit dobropis",
    resolutionNote: "Poznámka k vyřízení",
    resolveRefund: "Vyřídit a vrátit peníze",
    resolve: "Vyřídit",
  },
  documents: {
    title: "Dokumenty",
    contract: "Smlouva",
    itinerary: "Itinerář",
    offerPdf: "Nabídka PDF",
    offerTitle: "Sestaví PDF nabídky ze zájezdu, aktivní kalkulace, letů a znalostní báze země",
    check: "Zkontrolovat",
    checkTitle: "Před odesláním zkontroluje nabídku na nesrovnalosti (termíny, lety, ceny)",
    insurancePdf: "PDF pojištění",
    insuranceTitle: "Nahrát PDF pojistky od pojišťovny a připojit ho k této objednávce",
    offerConsistent: "✓ Nabídka je konzistentní — bez nálezů.",
    empty: "Zatím žádné dokumenty.",
    createdAt: "Vytvořeno {{date}}",
    signedAt: "Podepsáno {{date}}",
    sendForSignature: "Odeslat k podpisu",
    openPdf: "Otevřít PDF",
    copySignLink: "Kopírovat odkaz k podpisu",
  },
  invoices: {
    title: "Faktury a platby",
    proforma: "Proforma",
    final: "Konečná",
    empty: "Zatím nebyly vystaveny žádné faktury.",
    due: "splatnost {{date}}",
    openPdf: "Otevřít PDF",
    payments: "Platby",
  },
  portal: {
    title: "Zákaznický portál",
    hint: "Sdílejte magic link — bez přihlašování. Odkaz se zobrazí jen jednou; zkopírujte ho a pošlete zákazníkovi.",
    regenerate: "Vygenerovat znovu",
    createLink: "Vytvořit odkaz",
    copyLink: "Kopírovat odkaz",
    openLink: "Otevřít odkaz",
    offerRow: "Stránka nabídky (nabídka + přijetí)",
    portalRow: "Portál (pasy + platba)",
  },
  passports: {
    chipPnrOk: "PNR ✓",
    chipFuzzy: "zkontrolujte zápis jména",
    chipMissing: "není na PNR",
    chipNoPnr: "PNR zatím chybí",
    photoRestricted: "foto nedostupné",
    scanAlt: "Sken pasu",
    title: "Pasy a kontrola letenek",
    scansToConfirm_one: "{{count}} sken k potvrzení",
    scansToConfirm_few: "{{count}} skeny k potvrzení",
    scansToConfirm_other: "{{count}} skenů k potvrzení",
    uploadTitle: "Nahrajte fotografii pasu — MRZ se přečte a nabídne k potvrzení",
    upload: "Nahrát foto pasu",
    ticketCheck: "Kontrola letenek",
    checkSummary: "{{match}}/{{pax}} spárováno · {{checked}} zkontrolováno",
    ticket: "letenka: {{name}}",
    noPassport: "bez pasu",
    expiresTooSoon: "platnost do {{date}} — příliš brzy",
    checkedTitle: "Zkontrolováno — kliknutím zrušíte",
    markCheckedTitle:
      "Označit jméno a datum narození jako ověřené proti letence (kdo zkontroloval + datum)",
    checked: "zkontrolováno",
    markChecked: "označit jako zkontrolované",
    unmatchedPnr: "Na PNR, ale ne mezi účastníky: {{names}}",
    via: "zdroj: {{source}}",
    name: "Jméno",
    passport: "Pas",
    bornExpires: "Narození / platnost",
    nationality: "Státní příslušnost",
    mrzUnreadable:
      "MRZ nelze přečíst nebo neodpovídají kontrolní součty — přečtěte údaje z fotografie, zadejte je k účastníkovi ručně a sken poté odmítněte.",
    assignTraveller: "Přiřadit cestujícímu…",
    confirmIntoTraveller: "Potvrdit k cestujícímu",
    reject: "Odmítnout",
    pastePnr: "Vložit PNR (Amadeus)",
    pnrHint: "Vložte surový výpis z Amadeusu — segmenty a jména se zpracují automaticky",
    parse: "Zpracovat",
    attachToFlight: "Připojit k letecké rezervaci…",
    pax: "Cestující: {{names}}",
    locator: "Lokátor: {{locator}}",
    ignoredLines: "Ignorované řádky: {{n}}",
    noSegments: "Nebyly rozpoznány žádné letové segmenty — zkontrolujte vložený text.",
  },
  statusActions: {
    amount: "Částka (Kč)",
    noteOptional: "Poznámka (nepovinné)",
    notePlaceholder: "Např. referenční číslo, datum platby…",
    recordPayment: "Zaznamenat platbu",
    sendOffer: "Odeslat nabídku",
    resendOffer: "Znovu odeslat nabídku",
    confirmOrder: "Potvrdit objednávku",
    recordDeposit: "Zaznamenat zálohu",
    recordBalance: "Zaznamenat doplatek",
    markCompleted: "Označit jako dokončenou",
    sendOfferMessage:
      "Zákazníkovi se odešle personalizovaný e-mail s odkazem na online nabídku a objednávka se přesune do stavu Nabídnuto. Pokračovat?",
    confirmMessage: "Objednávka bude potvrzena a zákazníkovi se odešle e-mail s platebními pokyny.",
    completeMessage: "Objednávka bude označena jako dokončená.",
    complete: "Dokončit",
    cancelMessage: "Opravdu chcete tuto objednávku stornovat? Tuto akci nelze vzít zpět.",
    cancelOrder: "Stornovat objednávku",
    capacityTitle: "Kapacita bude překročena",
    capacityMessage:
      "Dojde k překročení kapacity ({{booked}}/{{capacity}} obsazeno, +{{pax}} nových = {{total}}). Přesto potvrdit?",
    confirmAnyway: "Přesto potvrdit",
    offerSent: "Nabídka odeslána {{date}}",
    viewed: "zobrazeno {{date}}",
    notViewed: "· zatím nezobrazeno",
    sendOfferFailed: "Nabídku se nepodařilo odeslat",
  },
};
